
const translations = {
  // Navbar
  "nav.home": "Startseite",
  "nav.destinations": "Reiseziele",
  "nav.bookings": "Buchungen",
  "nav.testimonials": "Bewertungen",
  "nav.blog": "Blog",
  "nav.prices": "Tarife",
  "nav.contact": "Kontakt",
  
  // Hero
  "hero.badge": "Premium-Service auf Fuerteventura",
  "hero.title1": "Entdecken Sie",
  "hero.title2": "Fuerteventura",
  "hero.title3": "Mit Stil",
  "hero.description": "Erleben Sie den Luxus, mit unserem exklusiven Premium-Transportservice über die Insel zu reisen. Hochwertige Fahrzeuge, professionelle Chauffeure und persönliche Betreuung.",
  "hero.bookNow": "Jetzt Buchen",
  "hero.viewDestinations": "Reiseziele Ansehen",
  
  // Destinos
  "destinations.title": "Exklusive Reiseziele",
  "destinations.subtitle": "Entdecken Sie die exklusivsten Ecken Fuerteventuras mit unserem Luxus-Transportservice",
  "destinations.from": "Ab",
  "destinations.duration": "Dauer",
  "destinations.book": "Buchen",
  
  // Reservas
  "bookings.title": "Buchen Sie Ihre Reise",
  "bookings.subtitle": "Füllen Sie das Formular aus und bestätigen Sie Ihre Premium-Buchung in Minuten",
  "bookings.origin": "Abfahrtsort",
  "bookings.destination": "Zielort",
  "bookings.date": "Datum",
  "bookings.time": "Uhrzeit",
  "bookings.passengers": "Passagiere",
  "bookings.name": "Vollständiger Name",
  "bookings.email": "E-Mail-Adresse",
  "bookings.phone": "Telefon",
  "bookings.submit": "Buchung Bestätigen",
  "bookings.selectOrigin": "Abfahrtsort wählen",
  "bookings.selectDestination": "Zielort wählen",
  
  // Testimonios
  "testimonials.title": "Bewertungen Ausgewählter Kunden",
  "testimonials.subtitle": "Über 5.000 anspruchsvolle Reisende vertrauen uns",
  "testimonials.verified": "Verifiziert",
  
  // Servicios
  "services.title": "Premium-Dienstleistungen",
  "services.subtitle": "Exzellenz und Distinktion bei jeder Fahrt",
  "services.vehicles": "Luxusflotte",
  "services.vehiclesDesc": "Mercedes V- und E-Klasse mit Lederausstattung, Premium-Klimaanlage und Highspeed-WLAN",
  "services.drivers": "Professionelle Chauffeure",
  "services.driversDesc": "Hochqualifiziertes Personal mit Protokollschulung und VIP-Betreuung",
  "services.punctuality": "Garantierte Pünktlichkeit",
  "services.punctualityDesc": "Absolutes Engagement für Ihre Zeit. GPS-Tracking in Echtzeit",
  "services.support": "24/7 Concierge",
  "services.supportDesc": "Persönlicher Assistenzservice rund um die Uhr verfügbar",
  
  // Precios
  "prices.title": "Premium-Tarife",
  "prices.subtitle": "Transparenz und Exklusivität bei jedem Service",
  "prices.popular": "Empfohlen",
  "prices.book": "Buchen",
  
  // Blog
  "blog.title": "Fuerteventura Reiseführer",
  "blog.subtitle": "Entdecken Sie die bestgehüteten Geheimnisse der Insel",
  "blog.readMore": "Mehr lesen",
  
  // Contacto
  "contact.title": "Kontakt",
  "contact.subtitle": "Zu Ihren Diensten",
  "contact.name": "Name",
  "contact.email": "E-Mail",
  "contact.message": "Nachricht",
  "contact.send": "Nachricht Senden",
  "contact.address": "Adresse",
  "contact.phone": "Telefon",
  "contact.hours": "Öffnungszeiten",
  "contact.hoursValue": "24/7 Service",
  
  // Footer
  "footer.destinations": "Reiseziele",
  "footer.services": "Dienstleistungen",
  "footer.information": "Information",
  "footer.legal": "Rechtliches",
  "footer.onlineBookings": "Online-Buchungen",
  "footer.rates": "Tarife",
  "footer.reviews": "Bewertungen",
  "footer.travelGuide": "Reiseführer",
  "footer.aboutUs": "Über Uns",
  "footer.faq": "Häufige Fragen",
  "footer.privacy": "Datenschutzrichtlinie",
  "footer.terms": "Allgemeine Geschäftsbedingungen",
  "footer.cookies": "Cookie-Richtlinie",
  "footer.legalNotice": "Impressum",
  "footer.since": "Seit 2010",
  "footer.rights": "Alle Rechte vorbehalten."
};

export default translations;
